import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from '../components/Header';
import Hero from '../components/home/Hero';
import Footer from '../components/Footer';
import AboutStats from '../components/about/AboutStats'
import ContactForm from '../components/contact/ContactForm'


import '../App.css';

export function Home() {
  const location = useLocation();

 useEffect(() => {
  if (location.hash) {
    const element = document.getElementById(location.hash.replace("#", ""));

    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }
}, [location]);

  return (
    <>
      <Header />
      <Hero />
      <AboutStats />
      <ContactForm />
      <Footer />
    </>
  );
}